export const GET_LMSPECIALHOURS_API_REQUEST = "GET_LMSPECIALHOURS_API_REQUEST";
export const GET_LMSPECIALHOURS_API_SUCCESS = "GET_LMSPECIALHOURS_API_SUCCESS";
export const GET_LMSPECIALHOURS_API_ERROR = "GET_LMSPECIALHOURS_API_ERROR";

export const POST_LMSPECIALHOURS_API_REQUEST = "POST_LMSPECIALHOURS_API_REQUEST";
export const POST_LMSPECIALHOURS_API_SUCCESS = "POST_LMSPECIALHOURS_API_SUCCESS";
export const POST_LMSPECIALHOURS_API_ERROR = "POST_LMSPECIALHOURS_API_ERROR";
